import styled from 'styled-components'

export const Collapse = styled.div`
    overflow: hidden;
    max-height: 0;
    transition: all 0.3s;

    ${props => props.isOpen && `
        max-height: 100%;
    `}
`